import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationDeliveryService } from 'src/app/Service/CalibrationDelivery/CalibrationDelivery.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';

@Component({
  selector: 'app-CalibrationDeliveryForm',
  templateUrl: './CalibrationDeliveryForm.component.html',
  styleUrls: ['./CalibrationDeliveryForm.component.scss']
})
export class CalibrationDeliveryFormComponent implements OnInit {

  Token: String = ""

  Procssing: boolean = false;
  FormSubmitted: boolean = false;

  constructor(
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
    private CalibrationDelivery_Service: CalibrationDeliveryService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
  }

  ResetForm() {
    this.FormSubmitted = false
    this.Info_Delivery_List = []
    this.QRCodeInputDelivery.nativeElement['value'] = ''
  }

  //#region Customer
  DataList_KarshnasMasol: Array<KarshnasMasol_Interface> = []
  ProcssingCustomer: boolean = false
  modalRef_Customer: any;
  page: number = 0

  Search_CodeName_Customer_Table: string = ''
  Data_Seleted_ReciveCustomer_Dsc: string = ''
  Search_Type_Customer_Table: string = '2'

  DataList_Customer: Array<Customer_List_Interface> = []
  Data_Seleted_Customer: Customer_List_Interface = Empty_Customer_List_Interface()


  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Token, this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }


  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }

  Set_Selected_Customer_Record(item) {
    this.Data_Seleted_Customer = item
    this.ReadData_Initial_Customer()
    this.modalRef_Customer.hide()
  }

  ReadData_Initial_Customer() {
    this.Customer_Service.GetSingle(this.Token, this.Data_Seleted_Customer.id).subscribe(
      data => {

        this.DataList_KarshnasMasol = data['karshnasMasol']



      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  //#endregion


  //#region Delivery
  Info_Delivery_List: Array<General_Interface> = []
  @ViewChild('QRCodeInputDelivery') QRCodeInputDelivery: ElementRef;

  QRCodeInputDelivery_Enter() {
    this.Get_Calibration_Info_Delivery(this.QRCodeInputDelivery.nativeElement['value'])
  }

  Get_Calibration_Info_Delivery(QRCodeInput: string) {

    if (!this.Procssing) {
      this.Procssing = true
      this.CalibrationDelivery_Service.GetInfobyQR(this.Token, this.Data_Seleted_Customer.id, QRCodeInput).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputDelivery_Esc()

          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("The scanned QR code is invalid")
          }
          else if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("The equipment identified by the scanned QR code has not entered the laboratory")
          }
          else if (data.id == -3) {
            this.Alertify_Service.ErrorMessage("The equipment identified by the scanned QR code has not left the laboratory")
          }
          else if (data.id == -4) {
            this.Alertify_Service.ErrorMessage("The equipment identified by the scanned QR code has already been delivered")
          }
          else if (data.id == -5) {
            this.Alertify_Service.ErrorMessage("The scanned QR code does not belong to customer " + this.Data_Seleted_Customer.name)
          }
          else if (this.Info_Delivery_Exist(data)) {
            this.Alertify_Service.ErrorMessage("The scanned QR code is already in the list")
          }
          else {
            data.dsc = QRCodeInput
            this.Info_Delivery_List.push(data)

            this.Alertify_Service.SuccessMessage("The instrument information was read successfully")
          }

        }, error => {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("The scanned QR code is invalid")

        }
      )
    }

  }

  QRCodeInputDelivery_Esc() {
    this.QRCodeInputDelivery.nativeElement['value'] = ''
  }

  Info_Delivery_Exist(input: General_Interface) {
    for (let item of this.Info_Delivery_List) {
      if (item.code == input.code) {
        return true
      }
    }
    return false
  }

  Info_Delivery_Remove(id: number) {
    this.Info_Delivery_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully")
    this.QRCodeInputDelivery.nativeElement.focus();
  }

  //#endregion


  Inperson: string = '-1'
  PersoneType: string = '0'

  InpersoneName: string = ''
  InpersonePhone: string = ''
  InpersoneCodeMeli: string = ''
  InpersoneDsc: string = ''

  CodeRahgiri: string = ''
  KarshnasMasol: string = '0'

  QRCodeChangeDelivery(datepickerInputStart) {

    if (this.Inperson == '1' && this.PersoneType == '0') {
      this.Alertify_Service.ErrorMessage("Please select the recipient")
    }
    else if (this.Inperson == '1' && !this.InpersoneName) {
      this.Alertify_Service.ErrorMessage("Please enter the name")
    }
    else if (this.Inperson == '1' && !this.InpersonePhone) {
      this.Alertify_Service.ErrorMessage("Please enter the contact number")
    }
    else if (this.Inperson == '0' && !this.KarshnasMasol) {
      this.Alertify_Service.ErrorMessage("Please select the calibration representative")
    }
    else {
      this.Procssing = true

      var Code: Array<string> = []
      for (let item of this.Info_Delivery_List) {
        Code.push(item.dsc)
      }

      this.CalibrationDelivery_Service.SubmitDelivery(
        Code,
        this.Data_Seleted_Customer.id,
        this.Inperson == '1',
        Number(this.PersoneType),
        this.CodeRahgiri,
        datepickerInputStart,
        Number(this.KarshnasMasol),
        this.InpersoneName,
        this.InpersonePhone,
        this.InpersoneDsc,
        this.InpersoneCodeMeli,
        this.Token).subscribe(
          data => {

            this.Procssing = false
            this.QRCodeInputDelivery_Esc()
            this.Info_Delivery_List = data

            this.FormSubmitted = true
            this.Alertify_Service.SuccessMessage("The equipment was verified for delivery")

          }
        )
    }
  }


}
